import { Avatar, Box, Button, CardMedia, Chip, Divider, Grid, Tab, Tabs, Typography } from '@mui/material';
import moment from 'moment';
import { IconButton } from '@mui/material';
import React, { useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import Reducer from '../../../services/Reducer';
import { GetAccountDetailsById, GetAccountList, GetDJDetails } from '../../../actions/authAction';
import toast from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import { BsPaypal } from 'react-icons/bs';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import HowToVoteOutlinedIcon from '@mui/icons-material/HowToVoteOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
// import PhoneIcon from '@mui/icons-material/PhoneEnabledOutlined';
import PhoneIcon from '@mui/icons-material/Phone';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LibraryMusicOutlinedIcon from '@mui/icons-material/LibraryMusicOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import CompareArrowsOutlinedIcon from '@mui/icons-material/CompareArrowsOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { GetUserRevenue, GetUserAssociatedEvents, GetEventDetails } from '../../../actions/mainAction';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});




function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const initState = {
    searchTerm: '',
    details: null,
    listingData: [],
    totalItem: '',
    loading: false,
    validate: false,
    revenueData: null,
    eventsData: [],
};
function AccountPreview() {
    const [state, dispatch] = useReducer(Reducer, initState);
    const navigate=useNavigate()
    const [value, setValue] = React.useState(0);
    const query = new URLSearchParams(window.location.search);
    const id = query.get('id');
    const userType = query.get('userType');
        const [page, setPage] = React.useState(1);
        const [limit] = React.useState(10);
        // const [userType, setUserType] = React.useState('DJ');

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleEventDetails = async (eventId, eventData) => {
        console.log('Event ID:', eventId);
        console.log('Event data:', eventData);
        if (eventId) {
            try {
                const response = await GetEventDetails(eventId);
                if (response.data?.status) {
                    // Navigate to event details page with the event data
                    navigate(`/user/event-details?id=${eventId}`);
                } else {
                    toast.error('Failed to fetch event details');
                }
            } catch (error) {
                console.error('Error fetching event details:', error);
                toast.error('Error fetching event details');
            }
        } else {
            toast.error('Event ID not found');
        }
    };


    const getAccountDetails = async (id) => {
        dispatch({ type: 'LOAD', payload: true });
        const response = await GetAccountDetailsById(id);
        if (response && response.data) {
            // setIsError(true)
            if (response.status === 200) {
                dispatch({ type: 'LOAD', payload: false });
                dispatch({ type: "SETDATA", payload: { "name": "details", "value": response.data.data } })
            } else {
                dispatch({ type: 'LOAD', payload: false });
                dispatch({ type: "SETDATA", payload: { "name": "details", "value": null } })
            }

        } else {
            dispatch({ type: 'LOAD', payload: false });
            toast.error('Something went wrong')
            // toast.error("Something went wrong");
        }
    }

    const djInfoAvailable = !!state.details?.isDjInfoAvailable;
    const orgInfoAvailable = !!state.details?.isOrganizerInfoAvailable;

    const getDJDetails = async (page, limit, userType, searchTerm) => {
        dispatch({ type: 'LOAD', payload: true });
        const response = await GetDJDetails(page, limit, userType, searchTerm);
        if (response && response.data) {
            // setIsError(true)
            console.log(response.data)
            if (response.status === 200) {
                dispatch({ type: 'LOAD', payload: false });
                dispatch({ type: "SETDATA", payload: { "name": "listingData", "value": response.data.data?.rows || [] } })
                dispatch({ type: "SETDATA", payload: { "name": "totalItem", "value": response.data.data?.totalCount || 0 } })
            } else {
                dispatch({ type: 'LOAD', payload: false });
                dispatch({ type: "SETDATA", payload: { "name": "listingData", "value": [] } })
                dispatch({ type: "SETDATA", payload: { "name": "totalItem", "value": 0 } })
            }

        } else {
            dispatch({ type: 'LOAD', payload: false });
            toast.error('Something went wrong')
            // toast.error("Something went wrong");
        }
    }

    const normalizeUserTypeForApi = (type) => {
        if (!type) return '';
        const t = String(type).toUpperCase();
        if (t === 'DJ') return 'DJ';
        if (t === 'ATTENDEE') return 'ATTENDEE';
        if (t === 'ORGANIZER' || t === 'ORGANISER') return 'ORGANIZER';
        return t;
    };

    const getRevenueAndEvents = async (userId, userType) => {
        dispatch({ type: 'LOAD', payload: true });
        const apiUserType = normalizeUserTypeForApi(userType);
        const [revRes, evRes] = await Promise.all([
            GetUserRevenue(userId, apiUserType),
            GetUserAssociatedEvents(userId, apiUserType)
        ]);
        dispatch({ type: 'LOAD', payload: false });
        if (revRes && revRes.status === 200) {
            dispatch({ type: 'SETDATA', payload: { name: 'revenueData', value: revRes?.data?.data || revRes?.data } });
        }
        if (evRes && evRes.status === 200) {
            const rows = evRes?.data?.data?.rows || evRes?.data?.data || evRes?.data || [];
            dispatch({ type: 'SETDATA', payload: { name: 'eventsData', value: Array.isArray(rows) ? rows : [] } });
        }
    };

    useEffect(() => {
        id && getAccountDetails(id)
        if (id && userType) {
            getRevenueAndEvents(id, userType);
        }
    }, [id, userType]);

    useEffect(() => {
        // Refetch revenue/events based on active tab user type
        if (!id) return;
        let typeForTab = null;
        if (value === 1 && djInfoAvailable) typeForTab = 'DJ';
        if (value === 2) typeForTab = 'ATTENDEE';
        if (value === 3 && orgInfoAvailable) typeForTab = 'ORGANIZER';
        if (typeForTab) {
            getRevenueAndEvents(id, typeForTab);
        }
    }, [value, id, djInfoAvailable, orgInfoAvailable]);

    useEffect(() => {
        if (userType === 'DJ') {
            setValue(1);
        } else if (userType === 'ATTENDEE') {
            setValue(2);
        } else if (userType === 'ORGANIZER' || userType === 'ORGANISER') {
            setValue(3);
        }
    }, [userType])
    useEffect(() => {
        if (value === 1 && !djInfoAvailable) {
            setValue(0);
        }
        if (value === 3 && !orgInfoAvailable) {
            setValue(0);
        }
        if (userType === 'DJ' && !djInfoAvailable) {
            setValue(0);
        }
        if ((userType === 'ORGANIZER' || userType === 'ORGANISER') && !orgInfoAvailable) {
            setValue(0);
        }
    }, [djInfoAvailable, orgInfoAvailable])
    return (

        <div className="listingPages">
            <Box maxWidth={1600} margin={'0 auto'}>
                <div class="payment-user-info-card">
                    <div class="top-info">
                        <figure>
                            <Avatar className='user-image' src={`${process.env.REACT_APP_S3_URL}${state.details?.profilePicture}`} alt={state.details?.firstName} style={{ backgroundColor: state.details?.colorCode }} />
                            <figcaption>
                                <h3>{state.details?.firstName} {state.details?.lastName}</h3>
                                <ul class="label-with-value-lists">
                                    <li class="w-100">
                                        <label>Email :</label>
                                        <p>{state.details?.email}</p>
                                    </li>
                                    <li class="w-100"><label>Phone Number :</label>
                                        <p>{state.details?.cc} {state.details?.phone}</p>
                                    </li>
                                </ul>
                            </figcaption>
                        </figure>
                    </div>
                </div>
                <Box sx={{ borderBottom: 1, borderColor: '#0057FF' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab icon={<InfoOutlinedIcon sx={{ color: '#fff' }} />} iconPosition="start" label="All Details" {...a11yProps(0)} />
                        {djInfoAvailable && <Tab icon={<LibraryMusicOutlinedIcon sx={{ color: '#fff' }} />} iconPosition="start" label="Dj" {...a11yProps(1)} />}
                        <Tab icon={<PersonOutlineOutlinedIcon sx={{ color: '#fff' }} />} iconPosition="start" label="Attendee" {...a11yProps(2)} />
                        {orgInfoAvailable && <Tab icon={<BusinessOutlinedIcon sx={{ color: '#fff' }} />} iconPosition="start" label="Organizer" {...a11yProps(3)} />}
                        {/* <Tab label="Other Details" {...a11yProps(2)} /> */}
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <Box borderRadius={'10px'} py={2} px={3} sx={{ backgroundColor: '#112E55' }}>
                        <Typography fontSize={20} color={'#fff'} marginBottom={2} fontWeight={600}>Basic Information</Typography>
                        <Divider sx={{ borderColor: '#32588B', opacity: 1 }} />
                        <Box marginTop={3} marginBottom={3}>
                            <Grid container spacing={{ xs: 1, sm: 2 }}>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Grid item container alignItems={'flex-start'} gap={2}>
                                        <Grid item paddingTop={1}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 19 19" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 8.32727C10.7427 8.32727 11.75 7.31991 11.75 6.07727C11.75 4.83463 10.7427 3.82727 9.5 3.82727C8.25732 3.82727 7.25 4.83463 7.25 6.07727C7.25 7.31991 8.25732 8.32727 9.5 8.32727ZM9.5 9.82727C11.5711 9.82727 13.25 8.14834 13.25 6.07727C13.25 4.00621 11.5711 2.32727 9.5 2.32727C7.42894 2.32727 5.75 4.00621 5.75 6.07727C5.75 8.14834 7.42894 9.82727 9.5 9.82727Z" fill="white" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.25 12.8273C5.59314 12.8273 4.25 14.1704 4.25 15.8273V16.5773C4.25 16.9915 3.91421 17.3273 3.5 17.3273C3.08579 17.3273 2.75 16.9915 2.75 16.5773V15.8273C2.75 13.342 4.76472 11.3273 7.25 11.3273H11.75C14.2353 11.3273 16.25 13.342 16.25 15.8273V16.5773C16.25 16.9915 15.9142 17.3273 15.5 17.3273C15.0858 17.3273 14.75 16.9915 14.75 16.5773V15.8273C14.75 14.1704 13.4068 12.8273 11.75 12.8273H7.25Z" fill="white" />
                                            </svg>
                                        </Grid>
                                        <Grid item width={'calc(100% - 46px)'}>
                                            <Typography color={'#BAD3F5'} fontSize={14}>Name</Typography>
                                            <Typography color={'#fff'}>{(state.details?.firstName || state.details?.lastName) ? `${state.details?.firstName || ''} ${state.details?.lastName || ''}`.trim() : 'NA'}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {/* <Grid item xs={12} sm={6} md={4}>
                                    <Grid item container alignItems={'flex-start'} gap={2}>
                                        <Grid item paddingTop={1}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 19 19" fill="none">
                                                <path d="M8.1875 2.63746V4.40938C8.01155 4.34719 7.82224 4.31336 7.625 4.31336C6.69302 4.31336 5.9375 5.06888 5.9375 6.00086C5.9375 6.93284 6.69302 7.68836 7.625 7.68836C8.55695 7.68836 9.3125 6.93284 9.3125 6.00086V1.87586C9.3125 1.69735 9.22775 1.52944 9.0842 1.42339C8.94057 1.31734 8.75518 1.28574 8.58455 1.33823L4.08458 2.72285C3.84855 2.79547 3.6875 3.01354 3.6875 3.26047V5.15938C3.51156 5.09719 3.32223 5.06336 3.125 5.06336C2.19302 5.06336 1.4375 5.81888 1.4375 6.75086C1.4375 7.68284 2.19302 8.43835 3.125 8.43835C4.05698 8.43835 4.8125 7.68284 4.8125 6.75086V3.67592L8.1875 2.63746Z" fill="white" />
                                                <path d="M10.2727 12.7736C10.4924 12.5539 10.4924 12.1978 10.2727 11.9781C10.053 11.7585 9.69693 11.7585 9.47726 11.9781L8.35226 13.1031C8.13258 13.3228 8.13258 13.6789 8.35226 13.8986C8.57193 14.1183 8.92803 14.1183 9.14771 13.8986L10.2727 12.7736Z" fill="white" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6771 6.11457C12.2148 4.57688 14.7079 4.57688 16.2456 6.11457C17.7833 7.65226 17.7833 10.1454 16.2456 11.683C15.5073 12.4214 14.5487 12.8052 13.5814 12.8345L8.91044 17.0303C7.94671 17.896 6.47409 17.8566 5.55802 16.9405L5.39606 16.7786C4.49261 15.8751 4.4401 14.4273 5.27572 13.4608L9.44962 8.63299C9.47699 8.60134 9.50707 8.57351 9.53932 8.54951C9.61792 7.6612 9.99719 6.79449 10.6771 6.11457ZM10.6771 11.683C11.1063 12.1122 11.6099 12.4216 12.1464 12.6112L8.15872 16.1934C7.63973 16.6596 6.84678 16.6383 6.35351 16.1451L6.19156 15.9831C5.70509 15.4966 5.6768 14.7171 6.12676 14.1966L9.69944 10.0642C9.88237 10.6565 10.2082 11.2142 10.6771 11.683Z" fill="white" />
                                            </svg>
                                        </Grid>
                                        <Grid item width={'calc(100% - 46px)'}>
                                            <Typography color={'#BAD3F5'} fontSize={14}>Genres</Typography>
                                            <Typography color={'#fff'}>{state.details?.userGenreDetail?.map((item, index) => (<span key={index}>{item?.genreDetail?.name},</span>))}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid> */}
                                <Grid item xs={12} sm={6} md={4}>
                                    <Grid item container alignItems={'flex-start'} gap={2}>
                                        <Grid item paddingTop={1}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 19 19" fill="none">
                                                <path d="M14.75 17.4384H4.25C3.70311 17.438 3.17874 17.2205 2.79203 16.8338C2.40532 16.4471 2.1879 15.9227 2.1875 15.3759V3.37585C2.1879 2.82897 2.40532 2.30459 2.79203 1.91789C3.17874 1.53118 3.70311 1.31375 4.25 1.31335H14.75C15.2969 1.31375 15.8213 1.53118 16.208 1.91789C16.5947 2.30459 16.8121 2.82897 16.8125 3.37585V15.3759C16.8121 15.9227 16.5947 16.4471 16.208 16.8338C15.8213 17.2205 15.2969 17.438 14.75 17.4384ZM4.25 2.43835C4.00148 2.43875 3.76325 2.53765 3.58753 2.71338C3.4118 2.88911 3.3129 3.12734 3.3125 3.37585V15.3759C3.3129 15.6244 3.4118 15.8626 3.58753 16.0383C3.76325 16.2141 4.00148 16.313 4.25 16.3134H14.75C14.9985 16.313 15.2367 16.2141 15.4125 16.0383C15.5882 15.8626 15.6871 15.6244 15.6875 15.3759V3.37585C15.6871 3.12734 15.5882 2.88911 15.4125 2.71338C15.2367 2.53765 14.9985 2.43875 14.75 2.43835H4.25Z" fill="white" />
                                                <path d="M12.875 14.8134H6.125C5.97582 14.8134 5.83274 14.7541 5.72725 14.6486C5.62176 14.5431 5.5625 14.4 5.5625 14.2509C5.5625 14.1017 5.62176 13.9586 5.72725 13.8531C5.83274 13.7476 5.97582 13.6884 6.125 13.6884H12.875C13.0242 13.6884 13.1673 13.7476 13.2727 13.8531C13.3782 13.9586 13.4375 14.1017 13.4375 14.2509C13.4375 14.4 13.3782 14.5431 13.2727 14.6486C13.1673 14.7541 13.0242 14.8134 12.875 14.8134Z" fill="white" />
                                                <path d="M12.875 12.5634H6.125C5.97582 12.5634 5.83274 12.5041 5.72725 12.3986C5.62176 12.2931 5.5625 12.15 5.5625 12.0009C5.5625 11.8517 5.62176 11.7086 5.72725 11.6031C5.83274 11.4976 5.97582 11.4384 6.125 11.4384H12.875C13.0242 11.4384 13.1673 11.4976 13.2727 11.6031C13.3782 11.7086 13.4375 11.8517 13.4375 12.0009C13.4375 12.15 13.3782 12.2931 13.2727 12.3986C13.1673 12.5041 13.0242 12.5634 12.875 12.5634Z" fill="white" />
                                                <path d="M11.75 10.3134C11.6008 10.3134 11.4577 10.2541 11.3523 10.1486C11.2468 10.0431 11.1875 9.90004 11.1875 9.75085C11.1875 9.3033 11.0097 8.87408 10.6932 8.55761C10.3768 8.24114 9.94755 8.06335 9.5 8.06335C9.05245 8.06335 8.62323 8.24114 8.30676 8.55761C7.99029 8.87408 7.8125 9.3033 7.8125 9.75085C7.8125 9.90004 7.75324 10.0431 7.64775 10.1486C7.54226 10.2541 7.39918 10.3134 7.25 10.3134C7.10082 10.3134 6.95774 10.2541 6.85225 10.1486C6.74676 10.0431 6.6875 9.90004 6.6875 9.75085C6.6875 9.00493 6.98382 8.28956 7.51126 7.76212C8.03871 7.23467 8.75408 6.93835 9.5 6.93835C10.2459 6.93835 10.9613 7.23467 11.4887 7.76212C12.0162 8.28956 12.3125 9.00493 12.3125 9.75085C12.3125 9.90004 12.2532 10.0431 12.1477 10.1486C12.0423 10.2541 11.8992 10.3134 11.75 10.3134Z" fill="white" />
                                                <path d="M9.5 8.06336C9.01791 8.06336 8.54664 7.9204 8.1458 7.65256C7.74495 7.38473 7.43253 7.00404 7.24804 6.55865C7.06356 6.11325 7.01529 5.62315 7.10934 5.15032C7.20339 4.67749 7.43554 4.24317 7.77643 3.90228C8.11732 3.56139 8.55164 3.32924 9.02447 3.23519C9.4973 3.14114 9.9874 3.18941 10.4328 3.3739C10.8782 3.55839 11.2589 3.87081 11.5267 4.27165C11.7945 4.6725 11.9375 5.14376 11.9375 5.62586C11.9367 6.27208 11.6796 6.8916 11.2227 7.34855C10.7657 7.8055 10.1462 8.06256 9.5 8.06336ZM9.5 4.31336C9.24041 4.31336 8.98665 4.39033 8.77082 4.53455C8.55498 4.67877 8.38675 4.88376 8.28741 5.12358C8.18807 5.36341 8.16208 5.62731 8.21272 5.88191C8.26336 6.13651 8.38837 6.37038 8.57192 6.55393C8.75548 6.73749 8.98935 6.86249 9.24395 6.91314C9.49855 6.96378 9.76245 6.93779 10.0023 6.83845C10.2421 6.73911 10.4471 6.57088 10.5913 6.35504C10.7355 6.1392 10.8125 5.88544 10.8125 5.62586C10.8121 5.27788 10.6737 4.94427 10.4276 4.69822C10.1816 4.45216 9.84798 4.31375 9.5 4.31336Z" fill="white" />
                                            </svg>
                                        </Grid>
                                        <Grid item width={'calc(100% - 46px)'}>
                                            <Typography color={'#BAD3F5'} fontSize={14}>Bio</Typography>
                                            <Typography color={'#fff'}>{state?.details?.bio}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                        <Typography fontSize={20} color={'#fff'} marginBottom={2} fontWeight={600}>Social Account</Typography>
                        <Divider sx={{ borderColor: '#32588B', opacity: 1 }} />
                        <Box marginTop={3} marginBottom={3}>
                            <Grid container spacing={{ xs: 1, sm: 2 }}>
                                {
                                    state?.details?.userSocialChannelDetail?.filter((it) => it?.label == 'Youtube').length > 0
                                    &&
                                    <Grid item xs={12} sm={6} md={4}>
                                        <Grid item container alignItems={'flex-start'} gap={2}>
                                            <Grid item paddingTop={1}>
                                                <img src='/images/youtube.svg' alt='' width={30} />
                                            </Grid>
                                            <Grid item width={'calc(100% - 46px)'}>
                                                <Typography color={'#BAD3F5'} fontSize={14}>YouTube</Typography>


                                                <Link to={`${state?.details?.userSocialChannelDetail?.filter((it) => it?.label == 'Youtube')[0]?.link}`} target="_blank">
                                                    <Typography color={'#fff'}>{state?.details?.userSocialChannelDetail?.filter((it) => it?.label == 'Youtube')[0]?.link}</Typography>
                                                </Link>

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }
                                {
                                    state?.details?.userSocialChannelDetail?.filter((it) => it?.label == 'Sound Cloud').length > 0
                                    &&
                                    <Grid item xs={12} sm={6} md={4}>
                                        <Grid item container alignItems={'flex-start'} gap={2}>
                                            <Grid item paddingTop={1}>
                                                <img src='/images/cloud.svg' alt='' width={30} />
                                            </Grid>
                                            <Grid item width={'calc(100% - 46px)'}>
                                                <Typography color={'#BAD3F5'} fontSize={14}>Sound Cloud</Typography>

                                                <Link to={`${state?.details?.userSocialChannelDetail?.filter((it) => it?.label == 'Sound Cloud')[0]?.link}`} target="_blank">
                                                    <Typography color={'#fff'}>{state?.details?.userSocialChannelDetail?.filter((it) => it?.label == 'Sound Cloud')[0]?.link}</Typography>
                                                </Link>

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }
                                {
                                    state?.details?.userSocialChannelDetail?.filter((it) => it?.label == 'Instagram').length > 0
                                    &&
                                    <Grid item xs={12} sm={6} md={4}>
                                        <Grid item container alignItems={'flex-start'} gap={2}>
                                            <Grid item paddingTop={1}>
                                                <img src='/images/instagram.svg' alt='' width={30} />
                                            </Grid>
                                            <Grid item width={'calc(100% - 46px)'}>
                                                <Typography color={'#BAD3F5'} fontSize={14}>Instagram</Typography>

                                                <Link to={`${state?.details?.userSocialChannelDetail?.filter((it) => it?.label == 'Instagram')[0]?.link}`} target="_blank">
                                                    <Typography color={'#fff'}>{state?.details?.userSocialChannelDetail?.filter((it) => it?.label == 'Instagram')[0]?.link}</Typography>

                                                </Link>

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }
                                {/* <Grid item xs={12} sm={6} md={4}>
                                    <Grid item container alignItems={'flex-start'} gap={2}>
                                        <Grid item paddingTop={1}>
                                            <img src='/images/spotify.svg' alt='' width={30} />
                                        </Grid>
                                        <Grid item width={'calc(100% - 46px)'}>
                                            <Typography color={'#0057FF'} fontSize={14}>Connected Media</Typography>
                                            <Typography color={'#fff'}>Spotify</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid> */}
                            </Grid>
                        </Box>
                        <Typography fontSize={20} color={'#fff'} marginBottom={2} fontWeight={600}> Bank Details</Typography>
                        <Divider sx={{ borderColor: '#32588B', opacity: 1 }} />
                        <Box marginTop={3} marginBottom={3}>
                            {state?.details?.userBankAccountDetail?.length > 0 ? (
                                state?.details?.userBankAccountDetail?.map((item, index) => (
                                    <Box key={index} mb={2}>
                                        <Grid container alignItems={'flex-start'} gap={2}>
                                            {/* <Grid item>
                                                {item?.bankType == 'PAYPAL' ? (
                                                    <BsPaypal color={'#fff'} />
                                                ) : (
                                                    <AccountBalanceOutlinedIcon sx={{ color: '#fff' }} />
                                                )}
                                            </Grid> */}
                                            <Grid item xs={12} sm={10} md={11}>
                                                <Grid container spacing={{ xs: 1, sm: 2 }}>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Grid item container alignItems={'flex-start'} gap={2}>
                                                            <Grid item paddingTop={1}>
                                                                <AccountCircleOutlinedIcon sx={{ color: '#fff' }} />
                                                            </Grid>
                                                            <Grid item width={'calc(100% - 46px)'}>
                                                                <Typography color={'#BAD3F5'} fontSize={14}>Account Holder Name</Typography>
                                                                <Typography color={'#fff'}>{item?.accountHolderName || 'NA'}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Grid item container alignItems={'flex-start'} gap={2}>
                                                            <Grid item paddingTop={1}>
                                                                <CreditCardOutlinedIcon sx={{ color: '#fff' }} />
                                                            </Grid>
                                                            <Grid item width={'calc(100% - 46px)'}>
                                                                <Typography color={'#BAD3F5'} fontSize={14}>Bank Account Number</Typography>
                                                                <Typography color={'#fff'}>{item?.bankAccountNumber ? `xxxxxxxxxx${item?.bankAccountNumber?.slice(-2)}` : 'NA'}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Grid item container alignItems={'flex-start'} gap={2}>
                                                            <Grid item paddingTop={1}>
                                                                <CompareArrowsOutlinedIcon sx={{ color: '#fff' }} />
                                                            </Grid>
                                                            <Grid item width={'calc(100% - 46px)'}>
                                                                <Typography color={'#BAD3F5'} fontSize={14}>Routing Number</Typography>
                                                                <Typography color={'#fff'}>{item?.routingNumber || 'NA'}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Grid item container alignItems={'flex-start'} gap={2}>
                                                            <Grid item paddingTop={1}>
                                                                <AccountBalanceOutlinedIcon sx={{ color: '#fff' }} />
                                                            </Grid>
                                                            <Grid item width={'calc(100% - 46px)'}>
                                                                <Typography color={'#BAD3F5'} fontSize={14}>Bank Name</Typography>
                                                                <Typography color={'#fff'}>{item?.bankName || 'NA'}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Grid item container alignItems={'flex-start'} gap={2}>
                                                            <Grid item paddingTop={1}>
                                                                <BadgeOutlinedIcon sx={{ color: '#fff' }} />
                                                            </Grid>
                                                            <Grid item width={'calc(100% - 46px)'}>
                                                                <Typography color={'#BAD3F5'} fontSize={14}>Tax ID</Typography>
                                                                <Typography color={'#fff'}>{item?.taxId || 'NA'}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                ))
                            ) : (
                                <Typography color={'#fff'}>NA</Typography>
                            )}
                        </Box>
                        {state?.details?.userBankAccountDetail?.some((a) => a?.paypalEmail) && (
                            <>
                                <Typography fontSize={20} color={'#fff'} marginBottom={2} fontWeight={600}>
                                    <Grid container alignItems={'center'} gap={1}>
                                        <Grid item><BsPaypal color={'#fff'} /></Grid>
                                        <Grid item>PayPal Details</Grid>
                                    </Grid>
                                </Typography>
                                <Divider sx={{ borderColor: '#0057FF', opacity: 1 }} />
                                <Box marginTop={3} marginBottom={3}>
                                    {state?.details?.userBankAccountDetail?.filter((a) => a?.paypalEmail)?.map((item, index) => (
                                        <Box key={`paypal-${index}`} mb={2}>
                                            <Grid container alignItems={'flex-start'} gap={2}>
                                                <Grid item xs={12} sm={10} md={11}>
                                                    <Grid container spacing={{ xs: 1, sm: 2 }}>
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Grid item container alignItems={'flex-start'} gap={2}>
                                                                <Grid item paddingTop={1}>
                                                                    <EmailOutlinedIcon sx={{ color: '#fff' }} />
                                                                </Grid>
                                                                <Grid item width={'calc(100% - 46px)'}>
                                                                    <Typography color={'#BAD3F5'} fontSize={14}>Paypal Email</Typography>
                                                                    <Typography color={'#fff'}>{item?.paypalEmail || 'NA'}</Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    ))}
                                </Box>
                            </>
                        )}
                    </Box>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    {djInfoAvailable ? (
                        (() => {
                            const listing = state.details;
                            return (
                            <Box borderRadius={'10px'} py={2} px={3} sx={{ backgroundColor: '#112E55' }} mb={2}>
                                <Typography fontSize={20} color={'#fff'} marginBottom={2} fontWeight={600}>Basic Information</Typography>
                                    <Divider sx={{ borderColor: '#32588B', opacity: 1 }} />
                                <Box marginTop={3} marginBottom={3}>
                                    <Grid container spacing={{ xs: 1, sm: 2 }}>
                                        {/* <Grid item xs={12} sm={6} md={4}>
                                            <Grid item container alignItems={'flex-start'} gap={2}>
                                                <Grid item paddingTop={1}>
                                                    <Avatar src={`${process.env.REACT_APP_S3_URL}${listing?.profilePicture || ''}`} alt={listing?.firstName || 'Profile'} sx={{ width: 64, height: 64 }} />
                                                </Grid>
                                                <Grid item width={'calc(100% - 46px)'}>
                                                    <Typography color={'#BAD3F5'} fontSize={14}>Profile Picture</Typography>
                                                    <Typography color={'#fff'}>{listing?.profilePicture ? 'Available' : '-'}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid> */}
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Grid item container alignItems={'flex-start'} gap={2}>
                                                <Grid item paddingTop={1}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 19 19" fill="none">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 8.32727C10.7427 8.32727 11.75 7.31991 11.75 6.07727C11.75 4.83463 10.7427 3.82727 9.5 3.82727C8.25732 3.82727 7.25 4.83463 7.25 6.07727C7.25 7.31991 8.25732 8.32727 9.5 8.32727ZM9.5 9.82727C11.5711 9.82727 13.25 8.14834 13.25 6.07727C13.25 4.00621 11.5711 2.32727 9.5 2.32727C7.42894 2.32727 5.75 4.00621 5.75 6.07727C5.75 8.14834 7.42894 9.82727 9.5 9.82727Z" fill="white" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.25 12.8273C5.59314 12.8273 4.25 14.1704 4.25 15.8273V16.5773C4.25 16.9915 3.91421 17.3273 3.5 17.3273C3.08579 17.3273 2.75 16.9915 2.75 16.5773V15.8273C2.75 13.342 4.76472 11.3273 7.25 11.3273H11.75C14.2353 11.3273 16.25 13.342 16.25 15.8273V16.5773C16.25 16.9915 15.9142 17.3273 15.5 17.3273C15.0858 17.3273 14.75 16.9915 14.75 16.5773V15.8273C14.75 14.1704 13.4068 12.8273 11.75 12.8273H7.25Z" fill="white" />
                                                    </svg>
                                                </Grid>
                                                <Grid item width={'calc(100% - 46px)'}>
                                                        <Typography color={'#BAD3F5'} fontSize={14}>Name (Stage Name)</Typography>
                                                    <Typography color={'#fff'}>{listing?.djName || 'NA'}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Grid item container alignItems={'flex-start'} gap={2}>
                                                <Grid item paddingTop={1}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 19 19" fill="none">
                                                        <path d="M8.1875 2.63746V4.40938C8.01155 4.34719 7.82224 4.31336 7.625 4.31336C6.69302 4.31336 5.9375 5.06888 5.9375 6.00086C5.9375 6.93284 6.69302 7.68836 7.625 7.68836C8.55695 7.68836 9.3125 6.93284 9.3125 6.00086V1.87586C9.3125 1.69735 9.22775 1.52944 9.0842 1.42339C8.94057 1.31734 8.75518 1.28574 8.58455 1.33823L4.08458 2.72285C3.84855 2.79547 3.6875 3.01354 3.6875 3.26047V5.15938C3.51156 5.09719 3.32223 5.06336 3.125 5.06336C2.19302 5.06336 1.4375 5.81888 1.4375 6.75086C1.4375 7.68284 2.19302 8.43835 3.125 8.43835C4.05698 8.43835 4.8125 7.68284 4.8125 6.75086V3.67592L8.1875 2.63746Z" fill="white" />
                                                        <path d="M10.2727 12.7736C10.4924 12.5539 10.4924 12.1978 10.2727 11.9781C10.053 11.7585 9.69693 11.7585 9.47726 11.9781L8.35226 13.1031C8.13258 13.3228 8.13258 13.6789 8.35226 13.8986C8.57193 14.1183 8.92803 14.1183 9.14771 13.8986L10.2727 12.7736Z" fill="white" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6771 6.11457C12.2148 4.57688 14.7079 4.57688 16.2456 6.11457C17.7833 7.65226 17.7833 10.1454 16.2456 11.683C15.5073 12.4214 14.5487 12.8052 13.5814 12.8345L8.91044 17.0303C7.94671 17.896 6.47409 17.8566 5.55802 16.9405L5.39606 16.7786C4.49261 15.8751 4.4401 14.4273 5.27572 13.4608L9.44962 8.63299C9.47699 8.60134 9.50707 8.57351 9.53932 8.54951C9.61792 7.6612 9.99719 6.79449 10.6771 6.11457ZM10.6771 11.683C11.1063 12.1122 11.6099 12.4216 12.1464 12.6112L8.15872 16.1934C7.63973 16.6596 6.84678 16.6383 6.35351 16.1451L6.19156 15.9831C5.70509 15.4966 5.6768 14.7171 6.12676 14.1966L9.69944 10.0642C9.88237 10.6565 10.2082 11.2142 10.6771 11.683Z" fill="white" />
                                                    </svg>
                                                </Grid>
                                                <Grid item width={'calc(100% - 46px)'}>
                                                        <Typography color={'#BAD3F5'} fontSize={14}>Genres</Typography>
                                                    <Typography color={'#fff'}>{(listing?.userGenreDetail && listing?.userGenreDetail?.length > 0) ? listing?.userGenreDetail?.map((item, idx) => (<span key={idx}>{item?.genreDetail?.name}{idx < (listing?.userGenreDetail?.length - 1) ? ', ' : ''}</span>)) : 'NA'}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Grid item container alignItems={'flex-start'} gap={2}>
                                                <Grid item paddingTop={1}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 19 19" fill="none">
                                                        <path d="M14.75 17.4384H4.25C3.70311 17.438 3.17874 17.2205 2.79203 16.8338C2.40532 16.4471 2.1879 15.9227 2.1875 15.3759V3.37585C2.1879 2.82897 2.40532 2.30459 2.79203 1.91789C3.17874 1.53118 3.70311 1.31375 4.25 1.31335H14.75C15.2969 1.31375 15.8213 1.53118 16.208 1.91789C16.5947 2.30459 16.8121 2.82897 16.8125 3.37585V15.3759C16.8121 15.9227 16.5947 16.4471 16.208 16.8338C15.8213 17.2205 15.2969 17.438 14.75 17.4384ZM4.25 2.43835C4.00148 2.43875 3.76325 2.53765 3.58753 2.71338C3.4118 2.88911 3.3129 3.12734 3.3125 3.37585V15.3759C3.3129 15.6244 3.4118 15.8626 3.58753 16.0383C3.76325 16.2141 4.00148 16.313 4.25 16.3134H14.75C14.9985 16.313 15.2367 16.2141 15.4125 16.0383C15.5882 15.8626 15.6871 15.6244 15.6875 15.3759V3.37585C15.6871 3.12734 15.5882 2.88911 15.4125 2.71338C15.2367 2.53765 14.9985 2.43875 14.75 2.43835H4.25Z" fill="white" />
                                                        <path d="M12.875 14.8134H6.125C5.97582 14.8134 5.83274 14.7541 5.72725 14.6486C5.62176 14.5431 5.5625 14.4 5.5625 14.2509C5.5625 14.1017 5.62176 13.9586 5.72725 13.8531C5.83274 13.7476 5.97582 13.6884 6.125 13.6884H12.875C13.0242 13.6884 13.1673 13.7476 13.2727 13.8531C13.3782 13.9586 13.4375 14.1017 13.4375 14.2509C13.4375 14.4 13.3782 14.5431 13.2727 14.6486C13.1673 14.7541 13.0242 14.8134 12.875 14.8134Z" fill="white" />
                                                        <path d="M12.875 12.5634H6.125C5.97582 12.5634 5.83274 12.5041 5.72725 12.3986C5.62176 12.2931 5.5625 12.15 5.5625 12.0009C5.5625 11.8517 5.62176 11.7086 5.72725 11.6031C5.83274 11.4976 5.97582 11.4384 6.125 11.4384H12.875C13.0242 11.4384 13.1673 11.4976 13.2727 11.6031C13.3782 11.7086 13.4375 11.8517 13.4375 12.0009C13.4375 12.15 13.3782 12.2931 13.2727 12.3986C13.1673 12.5041 13.0242 12.5634 12.875 12.5634Z" fill="white" />
                                                        <path d="M11.75 10.3134C11.6008 10.3134 11.4577 10.2541 11.3523 10.1486C11.2468 10.0431 11.1875 9.90004 11.1875 9.75085C11.1875 9.3033 11.0097 8.87408 10.6932 8.55761C10.3768 8.24114 9.94755 8.06335 9.5 8.06335C9.05245 8.06335 8.62323 8.24114 8.30676 8.55761C7.99029 8.87408 7.8125 9.3033 7.8125 9.75085C7.8125 9.90004 7.75324 10.0431 7.64775 10.1486C7.54226 10.2541 7.39918 10.3134 7.25 10.3134C7.10082 10.3134 6.95774 10.2541 6.85225 10.1486C6.74676 10.0431 6.6875 9.90004 6.6875 9.75085C6.6875 9.00493 6.98382 8.28956 7.51126 7.76212C8.03871 7.23467 8.75408 6.93835 9.5 6.93835C10.2459 6.93835 10.9613 7.23467 11.4887 7.76212C12.0162 8.28956 12.3125 9.00493 12.3125 9.75085C12.3125 9.90004 12.2532 10.0431 12.1477 10.1486C12.0423 10.2541 11.8992 10.3134 11.75 10.3134Z" fill="white" />
                                                        <path d="M9.5 8.06336C9.01791 8.06336 8.54664 7.9204 8.1458 7.65256C7.74495 7.38473 7.43253 7.00404 7.24804 6.55865C7.06356 6.11325 7.01529 5.62315 7.10934 5.15032C7.20339 4.67749 7.43554 4.24317 7.77643 3.90228C8.11732 3.56139 8.55164 3.32924 9.02447 3.23519C9.4973 3.14114 9.9874 3.18941 10.4328 3.3739C10.8782 3.55839 11.2589 3.87081 11.5267 4.27165C11.7945 4.6725 11.9375 5.14376 11.9375 5.62586C11.9367 6.27208 11.6796 6.8916 11.2227 7.34855C10.7657 7.8055 10.1462 8.06256 9.5 8.06336ZM9.5 4.31336C9.24041 4.31336 8.98665 4.39033 8.77082 4.53455C8.55498 4.67877 8.38675 4.88376 8.28741 5.12358C8.18807 5.36341 8.16208 5.62731 8.21272 5.88191C8.26336 6.13651 8.38837 6.37038 8.57192 6.55393C8.75548 6.73749 8.98935 6.86249 9.24395 6.91314C9.49855 6.96378 9.76245 6.93779 10.0023 6.83845C10.2421 6.73911 10.4471 6.57088 10.5913 6.35504C10.7355 6.1392 10.8125 5.88544 10.8125 5.62586C10.8121 5.27788 10.6737 4.94427 10.4276 4.69822C10.1816 4.45216 9.84798 4.31375 9.5 4.31336Z" fill="white" />
                                                    </svg>
                                                </Grid>
                                                <Grid item width={'calc(100% - 46px)'}>
                                                        <Typography color={'#BAD3F5'} fontSize={14}>Bio</Typography>
                                                    <Typography color={'#fff'}>{listing?.bio || 'NA'}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {/* Removed Wallet Amount & Vote Count from Basic Information as requested */}
                                    </Grid>
                                </Box>
                              
                            </Box>
                            )
                        })()
                    ) : (
                        !state.loading && (
                            <div className="nodata-found-table">
                                <h3>no account is still added!</h3>
                            </div>
                        )
                    )}

                    {/* Revenue section - dynamic and shown for DJ */}
                    <Box borderRadius={'10px'} py={2} px={3} sx={{ backgroundColor: '#112E55' }} mb={2}>
                        <Typography fontSize={20} color={'#fff'} marginBottom={2} fontWeight={600}>Revenue</Typography>
                        <Divider sx={{ borderColor: '#32588B', opacity: 1 }} />
                        <Box marginTop={3} marginBottom={3}>
                            <Grid item container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Box borderRadius={3} border={1} borderColor={'#33588A'} p={2}>
                                        <Box display={'flex'} justifyContent={'center'} mb={1}>
                                            <AccountBalanceWalletOutlinedIcon sx={{ fontSize: 32, color: '#BAD3F5' }} />
                                        </Box>
                                        <Typography fontSize={28} color={'#BAD3F5'} textAlign={'center'}>{(state?.revenueData?.referralAmount ?? state?.details?.referralAmount) || 0}</Typography>
                                        <Typography fontSize={14} color={'#BAD3F5'} textAlign={'center'}>Referral Amount</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box borderRadius={3} border={1} borderColor={'#33588A'} p={2}>
                                        <Box display={'flex'} justifyContent={'center'} mb={1}>
                                            <HowToVoteOutlinedIcon sx={{ fontSize: 32, color: '#BAD3F5' }} />
                                        </Box>
                                        <Typography fontSize={28} color={'#BAD3F5'} textAlign={'center'}>{(state?.revenueData?.voteCount ?? state?.details?.voteCount) || 0}</Typography>
                                        <Typography fontSize={14} color={'#BAD3F5'} textAlign={'center'}>Vote Count</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box borderRadius={3} border={1} borderColor={'#33588A'} p={2}>
                                        <Box display={'flex'} justifyContent={'center'} mb={1}>
                                            <AccountBalanceOutlinedIcon sx={{ fontSize: 32, color: '#BAD3F5' }} />
                                        </Box>
                                        <Typography fontSize={28} color={'#BAD3F5'} textAlign={'center'}>
                                            {((state?.revenueData?.totalEarning ?? state?.revenueData?.totalEarnings ?? state?.revenueData?.biddingAmount ?? state?.revenueData?.voteAmount ?? state?.details?.biddingAmount ?? state?.details?.voteAmount) || 0).toFixed(2)}
                                        </Typography>
                                        <Typography fontSize={14} color={'#BAD3F5'} textAlign={'center'}>Total Earning</Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>

                    <Box borderRadius={'10px'} py={2} px={3} sx={{ backgroundColor: '#112E55' }} mb={2}>
                        <Grid item container justifyContent={'space-between'} alignItems={'center'} mb={2}>
                            <Grid item>
                                <Typography fontSize={20} color={'#fff'} fontWeight={600}>Event</Typography>
                            </Grid>
                            <Grid item>
                                {!state?.eventsData.length?<></>:<Button variant='outlined' sx={{ color: '#0057FF', borderColor: '#0057FF', textTransform: 'capitalize' }} onClick={handleClickOpen} >View All</Button>}
                            </Grid>
                        </Grid>

                        <Divider sx={{ borderColor: '#32588B', opacity: 1 }} />
                        <Box marginTop={3} marginBottom={3}>
                            <Grid container spacing={2}>

                                {!state?.eventsData.length? <Grid item xs={12}>
                    <Typography color={"#fff"} textAlign={"center"}>
                      No Record found!
                    </Typography>
                  </Grid>:(state?.eventsData || []).slice(0, 4).map((ev, idx) => (
                                    <Grid item xs={12} sm={3} key={`ev-card-${idx}`}>
                                        <Box borderRadius={2} border={'1px solid #33588A'} p={2} sx={{ backgroundColor: '#112E55' }}>
                                            <Grid item container spacing={2} alignItems={'center'}>
                                                <Grid item width={96}>
                                                    <Box width={80} height={70} borderRadius={2} overflow={'hidden'}>
                                                        <CardMedia component={'img'} sx={{ height: '100%' }} src={`${process.env.REACT_APP_S3_URL}${ev?.logo || ev?.image || ev?.banner}` || '/images/event-1.png'} />
                                                    </Box>
                                                </Grid>
                                                <Grid item width={'calc(100% - 96px)'}>
                                                    <Typography fontWeight={600} color={'#fff'}>{ev?.eventName || ev?.title || ev?.name || 'Event'}</Typography>
                                                    {(ev?.address || ev?.venue || ev?.location || ev?.city) && (
                                                        <Typography fontSize={12} color={'#BAD3F5'}>{ev?.address || ev?.venue || ev?.location || ev?.city}</Typography>
                                                    )}
                                                    {(ev?.price || ev?.ticketPrice || ev?.cost) && (
                                                        <Typography fontSize={12} color={'#BAD3F5'}>${ev?.price || ev?.ticketPrice || ev?.cost}</Typography>
                                                    )}
                                                    {(ev?.date || ev?.startDate || ev?.eventDate) && (
                                                        <Typography fontSize={12} color={'#BAD3F5'}>{moment(ev?.date || ev?.startDate || ev?.eventDate).format('DD MMM YYYY')}</Typography>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            <Box pt={2}>
                                                <Divider sx={{ borderColor: '#32588B', opacity: 1, mb: 2 }} />
                                                <Grid item container spacing={2} alignItems={'center'} justifyContent={'space-between'}>
                                                    <Grid item>
                                                        <Chip label={ev?.associationType || ev?.role || 'Event'} sx={{ backgroundColor: '#bad3f5', color: '#00122a', borderRadius: 1, minWidth: 100 }} />
                                                    </Grid>
                                                    <Grid item>
                                                        <Button variant='contained' size='small' sx={{ backgroundColor: '#0057FF', textTransform: 'capitalize' }} onClick={() => handleEventDetails(ev?.eventId || ev?.id, ev)}>View Details</Button>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Box>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                    <Box borderRadius={'10px'} py={2} px={3} sx={{ backgroundColor: '#112E55' }} mb={2}>
                        <Typography fontSize={20} color={'#fff'} marginBottom={2} fontWeight={600}>Basic Information</Typography>
                        <Divider sx={{ borderColor: '#32588B', opacity: 1 }} />
                        <Box marginTop={3} marginBottom={3}>
                            <Grid container spacing={{ xs: 1, sm: 2 }}>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Grid item container alignItems={'flex-start'} gap={2}>
                                        <Grid item paddingTop={1}>
                                            <PersonOutlineOutlinedIcon sx={{ color: '#fff' }} />
                                        </Grid>
                                        <Grid item width={'calc(100% - 46px)'}>
                                            <Typography color={'#BAD3F5'} fontSize={14}>First Name</Typography>
                                            <Typography color={'#fff'}>{state?.details?.firstName || 'NA'}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Grid item container alignItems={'flex-start'} gap={2}>
                                        <Grid item paddingTop={1}>
                                            <PersonOutlineOutlinedIcon sx={{ color: '#fff' }} />
                                        </Grid>
                                        <Grid item width={'calc(100% - 46px)'}>
                                            <Typography color={'#BAD3F5'} fontSize={14}>Last Name</Typography>
                                            <Typography color={'#fff'}>{state?.details?.lastName || 'NA'}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Grid item container alignItems={'flex-start'} gap={2}>
                                        <Grid item paddingTop={1}>
                                            <EmailOutlinedIcon sx={{ color: '#fff' }} />
                                        </Grid>
                                        <Grid item width={'calc(100% - 46px)'}>
                                            <Typography color={'#BAD3F5'} fontSize={14}>Email ID</Typography>
                                            <Typography color={'#fff'}>{state?.details?.email || 'NA'}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Grid item container alignItems={'flex-start'} gap={2}>
                                        <Grid item paddingTop={1}>
                                            <PhoneIcon sx={{ color: '#fff' }} />
                                        </Grid>
                                        <Grid item width={'calc(100% - 46px)'}>
                                            <Typography color={'#BAD3F5'} fontSize={14}>Mobile Number</Typography>
                                            <Typography color={'#fff'}>{(state?.details?.cc || '') && (state?.details?.phone || '') ? `${state?.details?.cc} ${state?.details?.phone}` : (state?.details?.phone || 'NA')}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Grid item container alignItems={'flex-start'} gap={2}>
                                        <Grid item paddingTop={1}>
                                            <DescriptionOutlinedIcon sx={{ color: '#fff' }} />
                                        </Grid>
                                        <Grid item width={'calc(100% - 46px)'}>
                                            <Typography color={'#BAD3F5'} fontSize={14}>Description</Typography>
                                            <Typography color={'#fff'}>{state?.details?.bio || 'NA'}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                    {/* Revenue section - Attendee: only Referral Amount */}
                    <Box borderRadius={'10px'} py={2} px={3} sx={{ backgroundColor: '#112E55' }} mb={2}>
                        <Typography fontSize={20} color={'#fff'} marginBottom={2} fontWeight={600}>Revenue</Typography>
                        <Divider sx={{ borderColor: '#32588B', opacity: 1 }} />
                        <Box marginTop={3} marginBottom={3}>
                            <Grid item container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Box borderRadius={3} border={1} borderColor={'#33588A'} p={2}>
                                        <Box display={'flex'} justifyContent={'center'} mb={1}>
                                            <AccountBalanceWalletOutlinedIcon sx={{ fontSize: 32, color: '#BAD3F5' }} />
                                        </Box>
                                        <Typography fontSize={28} color={'#BAD3F5'} textAlign={'center'}>{(state?.revenueData?.referralAmount ?? state?.details?.referralAmount) || 0}</Typography>
                                        <Typography fontSize={14} color={'#BAD3F5'} textAlign={'center'}>Referral Amount</Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                    {/* Event section - Attendee */}
                    <Box borderRadius={'10px'} py={2} px={3} sx={{ backgroundColor: '#112E55' }} mb={2}>
                        <Grid item container justifyContent={'space-between'} alignItems={'center'} mb={2}>
                            <Grid item>
                                <Typography fontSize={20} color={'#fff'} fontWeight={600}>Event</Typography>
                            </Grid>
                            <Grid item>
                            {!state?.eventsData.length?<></>:<Button variant='outlined' sx={{ color: '#0057FF', borderColor: '#0057FF', textTransform: 'capitalize' }} onClick={handleClickOpen} >View All</Button>}
                            </Grid>
                        </Grid>
                        <Divider sx={{ borderColor: '#32588B', opacity: 1 }} />
                        <Box marginTop={3} marginBottom={3}>
                            <Grid container spacing={2}>
                                {!state?.eventsData.length? <Grid item xs={12}>
                    <Typography color={"#fff"} textAlign={"center"}>
                      No Record found!
                    </Typography>
                  </Grid>:(state?.eventsData || []).slice(0, 4).map((ev, idx) => (
                                    <Grid item xs={12} sm={3} key={`ev-attendee-card-${idx}`}>
                                        <Box borderRadius={2} border={'1px solid #33588A'} p={2} sx={{ backgroundColor: '#112E55', height: '100%', display: 'flex', flexDirection: 'column' }}>
                                            <Grid item container spacing={2} alignItems={'center'}>
                                                <Grid item width={96}>
                                                    <Box width={80} height={70} borderRadius={2} overflow={'hidden'}>
                                                        <CardMedia component={'img'} sx={{ height: '100%' }} src={`${process.env.REACT_APP_S3_URL}${ev?.logo || ev?.image || ev?.banner}` || '/images/event-1.png'} />
                                                    </Box>
                                                </Grid>
                                                <Grid item width={'calc(100% - 96px)'}>
                                                    <Typography fontWeight={600} color={'#fff'}>{ev?.eventName || ev?.title || ev?.name || 'Event'}</Typography>
                                                    {(ev?.address || ev?.venue || ev?.location || ev?.city) && (
                                                        <Typography fontSize={12} color={'#BAD3F5'}>{ev?.address || ev?.venue || ev?.location || ev?.city}</Typography>
                                                    )}
                                                    {(ev?.price || ev?.ticketPrice || ev?.cost) && (
                                                        <Typography fontSize={12} color={'#BAD3F5'}>${ev?.price || ev?.ticketPrice || ev?.cost}</Typography>
                                                    )}
                                                    {(ev?.date || ev?.startDate || ev?.eventDate) && (
                                                        <Typography fontSize={12} color={'#BAD3F5'}>{moment(ev?.date || ev?.startDate || ev?.eventDate).format('DD MMM YYYY')}</Typography>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            <Box pt={2} sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                                <Divider sx={{ borderColor: '#32588B', opacity: 1, mb: 2 }} />
                                                <Grid item container spacing={2} alignItems={'center'} justifyContent={'space-between'}>
                                                    <Grid item>
                                                        <Chip label={ev?.associationType || ev?.role || 'Attendee'} sx={{ backgroundColor: '#bad3f5', color: '#00122a', borderRadius: 1, minWidth: 100 }} />
                                                    </Grid>
                                                    <Grid item>
                                                        <Button variant='contained' size='small' sx={{ backgroundColor: '#0057FF', textTransform: 'capitalize' }} onClick={() => handleEventDetails(ev?.eventId || ev?.id, ev)}>View Details</Button>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Box>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3}>
                    {orgInfoAvailable ? (
                        (() => {
                            const listing = state.details;
                            return (
                            <Box borderRadius={'10px'} py={2} px={3} sx={{ backgroundColor: '#112E55' }} mb={2}>
                                <Typography fontSize={20} color={'#fff'} marginBottom={2} fontWeight={600}>Basic Information</Typography>
                                    <Divider sx={{ borderColor: '#32588B', opacity: 1 }} />
                                <Box marginTop={3} marginBottom={3}>
                                    <Grid container spacing={{ xs: 1, sm: 2 }}>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Grid item container alignItems={'flex-start'} gap={2}>
                                        
                                            <Grid item width={'calc(100% - 46px)'}>
                                                        <Typography color={'#BAD3F5'} fontSize={14}>Brand Logo</Typography>
                                                    {/* <Typography color={'#fff'}>{listing?.profilePicture ? 'Available' : '-'}</Typography> */}
                                                </Grid>
                                            <Grid item paddingTop={1}>
                                                    <Avatar src={`${process.env.REACT_APP_S3_URL}${listing?.profilePicture || ''}`} alt={listing?.firstName || 'Profile'} sx={{ width: 64, height: 64 }} />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Grid item container alignItems={'flex-start'} gap={2}>
                                        
                                                <Grid item paddingTop={1}>
                                                    <BusinessOutlinedIcon sx={{ color: '#fff' }} />
                                                </Grid>
                                                <Grid item width={'calc(100% - 46px)'}>
                                                        <Typography color={'#BAD3F5'} fontSize={14}>Business Name</Typography>
                                                    <Typography color={'#fff'}>{listing?.businessName || '-'}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Grid item container alignItems={'flex-start'} gap={2}>
                                                <Grid item paddingTop={1}>
                                                    <EmailOutlinedIcon sx={{ color: '#fff' }} />
                                                </Grid>
                                                <Grid item width={'calc(100% - 46px)'}>
                                                        <Typography color={'#BAD3F5'} fontSize={14}>Business Email</Typography>
                                                    <Typography color={'#fff'}>{listing?.businessEmail || '-'}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Grid item container alignItems={'flex-start'} gap={2}>
                                                <Grid item paddingTop={1}>
                                                    <PhoneIcon sx={{ color: '#fff' }} />
                                                </Grid>
                                                <Grid item width={'calc(100% - 46px)'}>
                                                        <Typography color={'#BAD3F5'} fontSize={14}>Business Phone</Typography>
                                                    <Typography color={'#fff'}>{listing?.businessCc} {listing?.businessPhone}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Grid item container alignItems={'flex-start'} gap={2}>
                                                <Grid item paddingTop={1}>
                                                    <HomeOutlinedIcon sx={{ color: '#fff' }} />
                                                </Grid>
                                                <Grid item width={'calc(100% - 46px)'}>
                                                        <Typography color={'#BAD3F5'} fontSize={14}>Business Address</Typography>
                                                    <Typography color={'#fff'}>{listing?.businessAddress || '-'}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Grid item container alignItems={'flex-start'} gap={2}>
                                                <Grid item paddingTop={1}>
                                                    <CategoryOutlinedIcon sx={{ color: '#fff' }} />
                                                </Grid>
                                                <Grid item width={'calc(100% - 46px)'}>
                                                        <Typography color={'#BAD3F5'} fontSize={14}>Categories</Typography>
                                                    <Typography color={'#fff'}>{listing?.userBusinessCategoryDetail?.map((c, idx) => (<span key={idx}>{c?.categoryDetail?.name || c?.categoryId}{idx < (listing?.userBusinessCategoryDetail?.length - 1) ? ', ' : ''}</span>))}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                                {Array.isArray(listing?.userImageDetail) && listing?.userImageDetail?.length > 0 && (
                                    <>
                                        <Typography fontSize={20} color={'#fff'} marginBottom={2} fontWeight={600}>Venue Photos</Typography>
                                        <Divider sx={{ borderColor: '#0057FF', opacity: 1 }} />
                                        <Box marginTop={3} marginBottom={3}>
                                            <Grid container spacing={{ xs: 1, sm: 2 }}>
                                                {listing?.userImageDetail?.map((imgItem, idx) => {
                                                    const imageKey = imgItem?.link || '';
                                                    if (!imageKey) return null;
                                                    const src = `${process.env.REACT_APP_S3_URL}${imageKey}`;
                                                    return (
                                                        <Grid item key={idx}>
                                                            <img src={src} alt={`user-image-${idx}`} style={{ width: 64, height: 64, objectFit: 'cover', borderRadius: 6 }} />
                                                        </Grid>
                                                    )
                                                })}
                                            </Grid>
                                        </Box>
                                    </>
                                )}
                            </Box>
                            )
                        })()
                    ) : (
                        !state.loading && (
                            <div className="nodata-found-table">
                                <h3>no account is still added!</h3>
                            </div>
                        )
                    )}
                    {/* Revenue section - dynamic and shown for Organizer */}
                    {orgInfoAvailable && (
                        <Box borderRadius={'10px'} py={2} px={3} sx={{ backgroundColor: '#112E55' }} mb={2}>
                            <Typography fontSize={20} color={'#fff'} marginBottom={2} fontWeight={600}>Revenue</Typography>
                            <Divider sx={{ borderColor: '#32588B', opacity: 1 }} />
                            <Box marginTop={3} marginBottom={3}>
                                <Grid item container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <Box borderRadius={3} border={1} borderColor={'#33588A'} p={2}>
                                            <Box display={'flex'} justifyContent={'center'} mb={1}>
                                                <AccountBalanceWalletOutlinedIcon sx={{ fontSize: 32, color: '#BAD3F5' }} />
                                            </Box>
                                            <Typography fontSize={28} color={'#BAD3F5'} textAlign={'center'}>{(state?.revenueData?.referralAmount ?? state?.details?.referralAmount) || 0}</Typography>
                                            <Typography fontSize={14} color={'#BAD3F5'} textAlign={'center'}>Referral Amount</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box borderRadius={3} border={1} borderColor={'#33588A'} p={2}>
                                            <Box display={'flex'} justifyContent={'center'} mb={1}>
                                                <HowToVoteOutlinedIcon sx={{ fontSize: 32, color: '#BAD3F5' }} />
                                            </Box>
                                            <Typography fontSize={28} color={'#BAD3F5'} textAlign={'center'}>{(state?.revenueData?.voteCount ?? state?.details?.voteCount) || 0}</Typography>
                                            <Typography fontSize={14} color={'#BAD3F5'} textAlign={'center'}>Vote Count</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box borderRadius={3} border={1} borderColor={'#33588A'} p={2}>
                                            <Box display={'flex'} justifyContent={'center'} mb={1}>
                                                <AccountBalanceOutlinedIcon sx={{ fontSize: 32, color: '#BAD3F5' }} />
                                            </Box>
                                            <Typography fontSize={28} color={'#BAD3F5'} textAlign={'center'}>
                                            {((state?.revenueData?.totalEarning ?? state?.revenueData?.totalEarnings ?? state?.revenueData?.biddingAmount ?? state?.revenueData?.voteAmount ?? state?.details?.biddingAmount ?? state?.details?.voteAmount) || 0).toFixed(2)}
                                        </Typography>
                                            <Typography fontSize={14} color={'#BAD3F5'} textAlign={'center'}>Total Earning</Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    )}
                    {/* Event section - replicate from DJ for Organizer */}
                    {orgInfoAvailable && (
                        <Box borderRadius={'10px'} py={2} px={3} sx={{ backgroundColor: '#112E55' }} mb={2}>
                            <Grid item container justifyContent={'space-between'} alignItems={'center'} mb={2}>
                                <Grid item>
                                    <Typography fontSize={20} color={'#fff'} fontWeight={600}>Event</Typography>
                                </Grid>
                                <Grid item>
                                {!state?.eventsData.length?<></>:<Button variant='outlined' sx={{ color: '#0057FF', borderColor: '#0057FF', textTransform: 'capitalize' }} onClick={handleClickOpen} >View All</Button>}
                                </Grid>
                            </Grid>
                            <Divider sx={{ borderColor: '#32588B', opacity: 1 }} />
                            <Box marginTop={3} marginBottom={3}>
                                <Grid container spacing={2}>
                                    {!state?.eventsData.length? <Grid item xs={12}>
                    <Typography color={"#fff"} textAlign={"center"}>
                      No Record found!
                    </Typography>
                  </Grid>:(state?.eventsData || []).slice(0, 4).map((ev, idx) => (
                                        <Grid item xs={12} sm={3} key={`ev-org-card-${idx}`}>
                                            <Box borderRadius={2} border={'1px solid #33588A'} p={2} sx={{ backgroundColor: '#112E55' }}>
                                                <Grid item container spacing={2} alignItems={'center'}>
                                                    <Grid item width={96}>
                                                        <Box width={80} height={70} borderRadius={2} overflow={'hidden'}>
                                                            <CardMedia component={'img'} sx={{ height: '100%' }} src={`${process.env.REACT_APP_S3_URL}${ev?.logo || ev?.image || ev?.banner}` || '/images/event-1.png'} />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item width={'calc(100% - 96px)'}>
                                                        <Typography fontWeight={600} color={'#fff'}>{ev?.eventName || ev?.title || ev?.name || 'Event'}</Typography>
                                                        {(ev?.address || ev?.venue || ev?.location || ev?.city) && (
                                                            <Typography fontSize={12} color={'#BAD3F5'}>{ev?.address || ev?.venue || ev?.location || ev?.city}</Typography>
                                                        )}
                                                        {(ev?.price || ev?.ticketPrice || ev?.cost) && (
                                                            <Typography fontSize={12} color={'#BAD3F5'}>${ev?.price || ev?.ticketPrice || ev?.cost}</Typography>
                                                        )}
                                                        {(ev?.date || ev?.startDate || ev?.eventDate) && (
                                                            <Typography fontSize={12} color={'#BAD3F5'}>{moment(ev?.date || ev?.startDate || ev?.eventDate).format('DD MMM YYYY')}</Typography>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                                <Box pt={2}>
                                                    <Divider sx={{ borderColor: '#32588B', opacity: 1, mb: 2 }} />
                                                    <Grid item container spacing={2} alignItems={'center'} justifyContent={'space-between'}>
                                                        <Grid item>
                                                            <Chip label={ev?.associationType || ev?.role || 'Organizer'} sx={{ backgroundColor: '#bad3f5', color: '#00122a', borderRadius: 1, minWidth: 100 }} />
                                                        </Grid>
                                                        <Grid item>
                                                            <Button variant='contained' size='small' sx={{ backgroundColor: '#0057FF', textTransform: 'capitalize' }} onClick={() => handleEventDetails(ev?.eventId || ev?.id, ev)}>View Details</Button>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        </Box>
                    )}
                </CustomTabPanel>
            </Box>

            <Dialog
                open={open}
                slots={{
                    transition: Transition,
                }}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
                className='custom_modal'
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle>{"All Events"}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        {(state?.eventsData || []).map((ev, idx) => (
                            <Grid item xs={12} sm={3} key={`ev-modal-${idx}`}>
                                <Box borderRadius={2} border={'1px solid #33588A'} p={2} sx={{ backgroundColor: '#112E55' }}>
                                    <Grid item container spacing={2} alignItems={'center'}>
                                        <Grid item width={96}>
                                            <Box width={80} height={70} borderRadius={2} overflow={'hidden'}>
                                                <CardMedia component={'img'} sx={{ height: '100%' }} src={`${process.env.REACT_APP_S3_URL}${ev?.logo || ev?.image || ev?.banner}` || '/images/event-1.png'} />
                                            </Box>
                                        </Grid>
                                        <Grid item width={'calc(100% - 96px)'}>
                                            <Typography fontWeight={600} color={'#fff'}>{ev?.eventName || ev?.title || ev?.name || 'Event'}</Typography>
                                            {(ev?.address || ev?.venue || ev?.location || ev?.city) && (
                                                <Typography fontSize={12} color={'#BAD3F5'}>{ev?.address || ev?.venue || ev?.location || ev?.city}</Typography>
                                            )}
                                            {(ev?.price || ev?.ticketPrice || ev?.cost) && (
                                                <Typography fontSize={12} color={'#BAD3F5'}>${ev?.price || ev?.ticketPrice || ev?.cost}</Typography>
                                            )}
                                            {(ev?.date || ev?.startDate || ev?.eventDate) && (
                                                <Typography fontSize={12} color={'#BAD3F5'}>{moment(ev?.date || ev?.startDate || ev?.eventDate).format('DD MMM YYYY')}</Typography>
                                            )}
                                        </Grid>
                                    </Grid>
                                    <Box pt={2}>
                                        <Divider sx={{ borderColor: '#32588B', opacity: 1, mb: 2 }} />
                                        <Grid item container spacing={2} alignItems={'center'} justifyContent={'space-between'}>
                                            <Grid item>
                                                <Chip label={ev?.associationType || ev?.role || 'Event'} sx={{ backgroundColor: '#bad3f5', color: '#00122a', borderRadius: 1, minWidth: 100 }} />
                                            </Grid>
                                            <Grid item>
                                                <Button variant='contained' size='small' sx={{ backgroundColor: '#0057FF', textTransform: 'capitalize' }} onClick={() => handleEventDetails(ev?.eventId || ev?.id, ev)}>View Details</Button>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} sx={{ color: '#0057FF', textTransform: 'capitalize' }}>close</Button>
                </DialogActions>
            </Dialog>
        </div>


    )
}

export default AccountPreview
